const navigationCount = ref<number>(0);

export function useNavigationClick() {
  const router = useRouting();

  function PreventSpam(isBack: boolean, callback: () => void) {
    if (navigationCount.value < 1 && !isBack) {
      navigationCount.value++;
      callback();
    } else if (navigationCount.value < 1 && isBack) {
      navigationCount.value = 0;
      callback();
    } else {
      navigationCount.value = 0;
    }
  }

  function NavigateForward(path: (string | number) []) {
    PreventSpam(false, () => router.forward(...path));
  }

  function NavigateSideways(path: string, replaceEntirePath = false, skipPreventSpam = false) {
    if (skipPreventSpam) {
      router.replace(path, replaceEntirePath);
    } else {
      PreventSpam(false, () => router.sideways(path, replaceEntirePath));
    }
  }

  function NavigateBack(path: string, jumpCount: number, absolute: boolean) {
    navigationCount.value = 0;
    PreventSpam(true, () => {
      router.back(path, jumpCount, absolute);
    });
  }

  return {
    router,
    NavigateForward,
    NavigateSideways,
    NavigateBack
  };
}
